import React from 'react'
import CountUp from 'react-countup'

const Count = ({ count }) => {
  return (
    <CountUp
      className="block text-xl leading-none"
      end={count}
      separator="."
      redraw={true}
    />
  )
}

const Numbers = ({
  epoca,
  incidentes,
  acumulados,
  comunas,
  className,
  globalMode,
}) => {
  return (
    <div className={`p-2 sm:p-4 numbers ${className ? className : ''}`}>
      <h2 className="text-sm leading-none sm:text-base ">
        <span>{epoca}</span>
      </h2>

      <h4 className="pt-1 text-3xl leading-none sm:pt-2">
        <small className="block text-xs leading-none">
          Incidentes
          <br /> acumulados
        </small>
        <Count count={acumulados} />
      </h4>
      {!globalMode && (
        <h4 className="pt-1 text-3xl leading-none sm:pt-2">
          <small className="block text-xs leading-none">
            Incidentes
            <br /> del semestre
          </small>
          <Count count={incidentes} />
        </h4>
      )}
      <h4 className="pt-1 text-3xl leading-none sm:pt-2">
        <small className="block text-xs leading-none">
          Comunas
          <br /> Afectadas
        </small>
        <Count count={comunas} />
      </h4>
    </div>
  )
}

export default Numbers
